import { ff } from '@atlassian/jira-feature-flagging';
import { applyFilter as applyAttributeFilter } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/filters/attribute-filter';
import { getFiltersViewSettings } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/view-settings';
import { getIssueIdsWithWarnings } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/warnings';
import type { Issue } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/issues/types';
import {
	WARNING_FILTER_ID,
	type WarningFilter,
	type PersistableWarningFilter,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/view-settings/filters/types';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';
import { createSelector } from '@atlassian/jira-portfolio-3-portfolio/src/common/reselect';

export type { WarningFilter } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/view-settings/filters/types';

export { WARNING_FILTER_ID } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/view-settings/filters/types';

export const applyFilter = (
	issue: Issue,
	{ value, issueIdsWithWarnings }: WarningFilter,
): boolean => {
	if (ff('plans-warning-filter-rework_7pi1k')) {
		return true;
	}
	if (value && !issueIdsWithWarnings.length) {
		return false;
	}
	return !value || applyAttributeFilter(issue, issueIdsWithWarnings, 'id');
};

export const getWarningFilterPure = (state: State): PersistableWarningFilter =>
	getFiltersViewSettings(state)[WARNING_FILTER_ID] || {
		id: WARNING_FILTER_ID,
		issueIdsWithWarnings: [],
		value: false,
	};

export const getWarningFilter = createSelector(
	[getIssueIdsWithWarnings, getWarningFilterPure],
	(issueIdsWithWarnings: string[], pureFilter: PersistableWarningFilter): WarningFilter => {
		const { value } = pureFilter;
		return {
			id: WARNING_FILTER_ID,
			value: ff('plans-warning-filter-rework_7pi1k') ? false : value,
			issueIdsWithWarnings,
		};
	},
);
